<template>
  <div class="pe-site-plan-design-grade">
    <TemplateDataGrid ref="grid"
                      gridId="PeSitePlanCourse"
                      v-bind="gridParams"></TemplateDataGrid>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'PeSitePlanDesignGrade',
  components: {
    TemplateDataGrid
  },
  props: {
    siteId: {
      type: String,
      required: true
    },
    plan: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  computed: {
    gridParams () {
      return {
        siteId: this.siteId,
        planId: this.plan.id
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.grid.loadGridData()
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .pe-site-plan-design-grade {
    height: 100%;
  }
</style>
